import { BusinessTypeData, BusinessTypeDataServer } from 'interfaces/api/templates.interfaces'

export const businessTypesMapper = (data: BusinessTypeData): BusinessTypeDataServer => ({
  title: {
    en: data.title,
    ru: data.title,
  },
  code: data.code,
  pythonTypeCode: data.pythonTypeCode,
})
